module.exports = __webpack_public_path__ + "static/media/computer-rocket.f708aedd.png";